import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose } from 'recompose'
import { List, ListDivider } from 'react-toolbox/lib/list';
import ListItem from './ListItem'

import styles from './styles.scss'

const Divider = () => <ListDivider theme={styles}/>

const ClockList = ({items}) => {
  return (
    <List theme={styles}>
      {
        items.reduce(
          (result, value, index) => {
            if (value.enabled) {
              let item = <ListItem key={index} {...value}/>
              result.push(item)
              result.push(<Divider key={`divider_${index}`}/>)
            }
            return result
          },
          [<Divider key='divider'/>]
        )
      }
    </List>
  )
}

ClockList.propTypes = {
  items: PropTypes.array.isRequired
}

const withStyle = CSSModules(styles)
export default withStyle(ClockList)
